import validate from "/usr/src/app/content/n3-spas-8ec4bb9f-cef7-4dd2-9089-51b266964cab/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-8ec4bb9f-cef7-4dd2-9089-51b266964cab/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}